import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center space-x-3">
            <img 
              src="https://dathent.com/icon.png" 
              alt="Dathent Logo" 
              className="h-8 w-8 sm:h-10 sm:w-10"
            />
            <span className="text-xl sm:text-2xl font-bold text-gray-900">Dathent</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')} 
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Услуги
            </button>
            <button 
              onClick={() => scrollToSection('why-us')} 
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Почему мы
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')} 
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Отзывы
            </button>
            <Button 
              onClick={() => scrollToSection('cta')} 
              className="bg-[#FFD700] hover:bg-[#E5C200] text-gray-900 font-semibold shadow-md transition-all"
            >
              Консультация
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('services')} 
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left"
              >
                Услуги
              </button>
              <button 
                onClick={() => scrollToSection('why-us')} 
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left"
              >
                Почему мы
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')} 
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left"
              >
                Отзывы
              </button>
              <Button 
                onClick={() => scrollToSection('cta')} 
                className="bg-[#FFD700] hover:bg-[#E5C200] text-gray-900 font-semibold w-full"
              >
                Консультация
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
